export default "__VITE_ASSET__Cd7npdja__"